var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "80px",
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23 Copy 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.24400098e-13%",
    y1: "1.2204647e-12%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C8F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D41E1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-802.000000, -964.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Companies-Box-Copy-2",
    transform: "translate(0.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19-Copy-3",
    transform: "translate(787.500000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-3",
    transform: "translate(15.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon-Copy-16",
    fill: "url(#linearGradient-1)",
    points: "40 0 74.6410162 20 74.6410162 60 40 80 5.35898385 60 5.35898385 20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-approval-1733358",
    transform: "translate(26.000000, 22.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 5 23 5 23 6 4 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 9 23 9 23 10 4 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 12 13 12 13 13 4 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 16 11 16 11 17 4 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5104603,11.8125 L26.5104603,0 L0,0 L0,36 L23.6861925,36 C30.4644351,36 36,30.4875 36,23.7375 C36,17.9626339 31.9330544,13.0875 26.5104603,11.8125 Z M1.31799163,34.6875 L1.31799163,1.3125 L25.1924686,1.3125 L25.1924686,11.5875 C24.7028482,11.5124263 24.175665,11.4750201 23.686327,11.4750201 C16.9080843,11.4750201 11.3725194,16.9875201 11.3725194,23.7375201 C11.3725194,28.5000871 14.1214062,32.6250201 18.1131052,34.6500201 L1.31799163,34.6875 Z M23.6861925,34.6875 C17.623431,34.6875 12.6903766,29.775067 12.6903766,23.7375 C12.6903766,17.7 17.6233637,12.7875 23.6861925,12.7875 C29.7490212,12.7875 34.6820084,17.699933 34.6820084,23.7375 C34.6820084,29.775 29.7490212,34.6875 23.6861925,34.6875 L23.6861925,34.6875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6800471,20.1800204 L20.85462,26.0664679 L18.4005339,23.4505285 C18.0937389,23.1427204 17.59515,23.1043449 17.2501126,23.4121537 C16.9433176,23.7199618 16.9050684,24.2201971 17.211864,24.5663739 L20.2027815,27.7595264 C20.3945618,27.95194 20.6245912,28.028959 20.8928563,27.9903155 C21.0461202,27.9519407 21.1996513,27.9132965 21.314666,27.797902 L28.7152695,21.4112534 C29.0603137,21.1034453 29.09883,20.6032099 28.792035,20.2570332 C28.5234892,19.9492251 27.986651,19.9108495 27.6798903,20.1800142 L27.6800471,20.1800204 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.8a9947068a470c74a98bc92151dc26f6.svg";
export { ForwardRef as ReactComponent };